/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2018-07-09 17:52:52
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2019-01-01 17:15:46
 */

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";

import { Store } from "@ngrx/store";
import { AppState } from "../app/app.reducer";
import { AuthState } from "../store/auth/auth.state";
import { ENV } from "../env/env";
import { User } from "../models/user.model";
import { KakaoService } from "../services-sns/kakao.service";
import { TransService } from "./trans.service";
import { FacebookService } from "../services-sns/facebook.service";
import { LineService } from "../services-sns/line.service";

@Injectable()
export class AuthService {
  // private checkValue: string;
  // private tmpEmail: string;
  // private tmpPassword: string;

  private alias = "celeb";

  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/auth`;

  private authInfo = {
    token: "",
    userId: ""
  };

  private userInfo: User;

  constructor(
    private transService: TransService,
    private kakaoService: KakaoService,
    private facebookService: FacebookService,
    private lineService: LineService,
    private http: HttpClient,
    private storage: Storage,
    private store: Store<AppState>
  ) {
    this.store
      .select("auth")
      .filter(state => !!state)
      .subscribe((state: AuthState) => {
        this.userInfo = state.user;
      });
  }

  registerEmail(email: string, password: string) {
    // this.checkValue = '' + getRandomInt(100000, 999999);
    // this.tmpEmail = email;
    // this.tmpPassword = password;
    return this.http.post(
      `${this.url}/register?lang=${this.transService.lang}`,
      {
        email,
        password
        // checkValue: this.checkValue
      }
    );
  }

  // verifiedEmail(checkValue) {
  //   if (this.checkValue === checkValue) {
  //     this.store.dispatch(new AuthActions.Login(this.tmpEmail, this.tmpPassword, null));
  //     this.tmpEmail = '';
  //     this.tmpPassword = '';
  //     this.checkValue = '';
  //   }
  // }

  registerSns(snsId, provider) {
    return this.http.post(
      `${this.url}/register-sns?lang=${this.transService.lang}`,
      {
        snsId,
        provider
      }
    );
  }

  login(email: string, password: string, snsId: string, provider: string) {
    return this.http.post(`${this.url}/login?lang=${this.transService.lang}`, {
      email,
      password,
      snsId,
      provider
    });
  }

  forgotPassword(email: string) {
    return this.http.post(
      `${this.url}/forgot-password?lang=${this.transService.lang}`,
      {
        email
      }
    );
  }

  changePassword(curPassword, newPassword) {
    return this.http.post(
      `${this.url}/change-password?lang=${this.transService.lang}`,
      {
        curPassword,
        newPassword
      }
    );
  }

  checkEmail(email) {
    return this.http.get(
      `${this.url}/check-email?lang=${this.transService.lang}&email=${email}`
    );
  }

  setup() {
    return Promise.all([
      this.storage
        .get(`${this.alias}-token`)
        .then(value => (this.authInfo.token = value)),
      this.storage
        .get(`${this.alias}-userId`)
        .then(value => (this.authInfo.userId = value))
    ]);
  }

  get token() {
    return this.authInfo.token;
  }

  get userId() {
    return this.authInfo.userId;
  }

  get isLogin() {
    return !!this.userInfo;
  }

  isMe(user: User) {
    return user && this.userId === user._id;
  }

  set token(token: string) {
    this.authInfo.token = token;
    this.storage.set(`${this.alias}-token`, token);
  }

  set userId(userId: string) {
    this.authInfo.userId = userId;
    this.storage.set(`${this.alias}-userId`, userId);
  }

  set user(user) {
    this.userInfo = user;
  }

  get user() {
    return this.userInfo;
  }

  get isAdmin() {
    return (
      this.userInfo &&
      (this.userInfo.role === "ADMIN" || this.userInfo.role === "SUPER")
    );
  }

  get isCeleb() {
    return this.userInfo && this.userInfo.role === "CELEB";
  }

  get isManager() {
    return this.userInfo && this.userInfo.role === "MANAGER";
  }

  get isAccount() {
    return this.userInfo && this.userInfo.role === "ACCOUNT";
  }

  get isGuest() {
    return !this.userInfo;
  }

  clearAuthInfo() {
    if (this.userInfo && this.userInfo.provider === "KAKAO")
      this.kakaoService.logout();
    this.facebookService.logout();
    this.lineService.logout();

    this.authInfo = { token: "", userId: "" };
    this.storage.set(`${this.alias}-token`, "");
    this.storage.set(`${this.alias}-userId`, "");
  }
}



// WEBPACK FOOTER //
// ./src/services/auth.service.ts